import { MoveMovableItemActionResultDirection } from 'app/src/engine/action-results/MoveMovableItemActionResult';
import GameStateStore from 'app/src/game/GameStateStore';

export enum TileWallType {
	Top,
	Right,
	Bottom,
	Left,
}

export default class TileWalls {
	public static doesWallObstructMovement(
		gameStateStore: GameStateStore,
		row: number,
		col: number,
		movementDirection: MoveMovableItemActionResultDirection,
	): boolean {
		const currentTile = gameStateStore.getTile(row, col);

		if (
			(movementDirection === MoveMovableItemActionResultDirection.Up &&
				currentTile.walls.has(TileWallType.Top)) ||
			(movementDirection === MoveMovableItemActionResultDirection.Right &&
				currentTile.walls.has(TileWallType.Right)) ||
			(movementDirection === MoveMovableItemActionResultDirection.Down &&
				currentTile.walls.has(TileWallType.Bottom)) ||
			(movementDirection === MoveMovableItemActionResultDirection.Left &&
				currentTile.walls.has(TileWallType.Left))
		) {
			return true;
		}

		let nextRow = row;
		let nextCol = col;

		switch (movementDirection) {
			case MoveMovableItemActionResultDirection.Up:
				nextRow -= 1;
				break;
			case MoveMovableItemActionResultDirection.Right:
				nextCol += 1;
				break;
			case MoveMovableItemActionResultDirection.Down:
				nextRow += 1;
				break;
			case MoveMovableItemActionResultDirection.Left:
				nextCol -= 1;
				break;
		}

		if (
			nextRow < 0 ||
			nextRow >= gameStateStore.rows ||
			nextCol < 0 ||
			nextCol >= gameStateStore.cols
		) {
			return true;
		}

		const nextTile = gameStateStore.getTile(nextRow, nextCol);

		if (
			(movementDirection === MoveMovableItemActionResultDirection.Up &&
				nextTile.walls.has(TileWallType.Bottom)) ||
			(movementDirection === MoveMovableItemActionResultDirection.Right &&
				nextTile.walls.has(TileWallType.Left)) ||
			(movementDirection === MoveMovableItemActionResultDirection.Down &&
				nextTile.walls.has(TileWallType.Top)) ||
			(movementDirection === MoveMovableItemActionResultDirection.Left &&
				nextTile.walls.has(TileWallType.Right))
		) {
			return true;
		}

		return false;
	}
}
